<template>
    <v-form v-model="valid">
    <v-container fluid class="mt-4">
      <v-row dense>
        <v-col cols="12" sm="6" md="5">
          <v-text-field label="Name" v-model="wine.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
        </v-col>
        <v-col cols="6" sm="3" md="2">
          <v-text-field label="SKU" v-model="wine.sku" :rules="[fieldRules.maxLength(50)]" :counter="10" outlined dense/>
        </v-col>
        <v-col cols="2" lg="1">
          <v-checkbox label="Active" v-model="wine.active" dense class="mt-1"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="5">
          <v-autocomplete v-model="wine.type" outlined dense label="Type" :disabled="wine.id!=undefined"
                          :items="[{text:'Containing more than 7%',value:'WineHigh'},
                                   {text:'Containing more than 1.2%, but not more than 7%',value:'WineMedium'},
                                   {text:'Containing not more than 1.2%',value:'WineWeak'}]"
                          hint="Excise reporting classifies wine by strength"/>
        </v-col>
      </v-row>

      <v-row v-if="values && connectedToAccounting">
        <v-col cols="12" sm="6" md="4">
          <account-picker v-model="wine.inventoryAccountRef" label="Inventory asset account"
                          :accounts="accounts" :addTypes="['OtherCurrentAsset']"
                          hint="The inventory account used to track the value of this wine"/>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: 'WineEditInfo',
  props: {
    wine: {type:Object, required:true},
    accounts: {type:Array, required:true},
    values: {type:Boolean, required:true}
  },
  data() {
    return {
      valid: true
    }
  },
  computed: {
    connectedToAccounting() {
      return this.$store.getters.company.connectedToAccounting;
    }
  }
}
</script>